module.exports = {"id":"default","name":"Blackout","isInbuilt":true,"theme":{"type":"dark","palette":{"primaryColor":{"id":"indigo","shadeIndex":6},"secondaryColor":{"id":"orange","shadeIndex":5},"backgroundColor":{"id":"black","shadeIndex":8},"custom":{"today":"#1455c0","soon":"#FF9300","overdue":"#F00","later":"#22B30B","unreadItem":"#1455c0","highPriority":"orange"}},"hideTaskEditIcon":false,"isDense":false,"typography":{"useNextVariants":true}}}


//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-themes/Blackout.json
// module id = 704
// module chunks = 0